// Validation utility functions

export const parseServerErrors = (error: any): { [key: string]: string } => {
  const errors: { [key: string]: string } = {};
  
  if (error.response?.data) {
    const data = error.response.data;

    // F-BT-018: some endpoints (trade execute/send/post) answer a refusal with a
    // bare string body. Without this branch the map stayed empty and the
    // ticket rendered nothing — the operator saw a dead button.
    if (typeof data === 'string' && data.trim().length > 0) {
      errors.submit = data.trim();
      return errors;
    }

    // Handle validation errors from Spring Boot GlobalExceptionHandler
    // Returns Map<String, String> where keys are field names and values are error messages
    if (typeof data === 'object' && !Array.isArray(data) && !data.errors) {
      // This is a Map<String, String> format from GlobalExceptionHandler
      Object.keys(data).forEach((field) => {
        // 'type' is a response discriminator (e.g. {type: "VALIDATION_ERROR",
        // error: "..."}), not a form field — treating it as one masked the
        // real message in data.error below.
        if (field !== 'error' && field !== 'message' && field !== 'type') {
          errors[field] = data[field];
        }
      });
    }
    
    // Handle validation errors from Spring Boot (array format)
    if (data.errors && Array.isArray(data.errors)) {
      data.errors.forEach((err: any) => {
        const field = err.field || err.property || 'submit';
        errors[field] = err.message || err.defaultMessage || 'Invalid value';
      });
    }
    
    // Handle single error message
    if (data.message && !data.errors && Object.keys(errors).length === 0) {
      errors.submit = data.message;
    }
    
    // Handle error object
    if (data.error && typeof data.error === 'string' && Object.keys(errors).length === 0) {
      errors.submit = data.error;
    }
  }
  
  // Log the error for debugging
  if (Object.keys(errors).length > 0) {
    console.error('Validation errors:', errors);
    console.error('Full error response:', error.response?.data);
  }
  
  return errors;
};

